import React, { useState } from 'react';
import { useGate } from '../../context/GateContext';
import { useAuth } from '../../context/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import toast from 'react-hot-toast';

const { FiLock, FiArrowRight, FiShield } = FiIcons;

const PasswordGate = ({ section, children }) => {
  const { checkAccess, unlockSection } = useGate();
  const { user } = useAuth();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // Admins or previously unlocked sections bypass the gate
  if (user || checkAccess(section)) {
    return <>{children}</>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;
    
    setLoading(true);
    const result = await unlockSection(section, password);
    
    if (result.success) {
      toast.success(`Access granted!`);
    } else {
      toast.error('Incorrect password');
      setPassword('');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-6 text-center animate-in fade-in duration-700">
      <div className="w-20 h-20 bg-stone-100 rounded-[2rem] flex items-center justify-center mb-8 shadow-inner">
        <SafeIcon icon={FiLock} className="w-8 h-8 text-[#8c7851]" />
      </div>
      
      <div className="max-w-md space-y-4 mb-10">
        <h2 className="text-3xl font-serif font-bold capitalize text-[#2c2c2c]">
          {section} Collection
        </h2>
        <p className="text-stone-500 leading-relaxed">
          This branch of the archive is private. Please enter the family password to unlock these memories.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4">
        <div className="relative group">
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            placeholder="Enter password" 
            className="w-full px-6 py-4 rounded-2xl border-2 border-stone-100 bg-white focus:ring-4 focus:ring-[#8c7851]/5 focus:border-[#8c7851] outline-none transition-all text-center text-lg placeholder:text-stone-300"
            autoFocus
          />
        </div>
        <button 
          type="submit" 
          disabled={loading || !password} 
          className="w-full bg-[#2c2c2c] text-white py-4 rounded-2xl font-bold flex items-center justify-center space-x-3 hover:bg-black transition-all active:scale-[0.98] disabled:opacity-50 shadow-xl shadow-stone-200"
        >
          <span>{loading ? 'Verifying...' : 'Unlock Archive'}</span>
          {!loading && <SafeIcon icon={FiArrowRight} className="w-5 h-5" />}
        </button>
      </form>

      <div className="mt-16 flex items-center gap-2 text-[10px] font-bold text-stone-300 uppercase tracking-[0.2em]">
        <SafeIcon icon={FiShield} className="w-3 h-3" />
        <span>End-to-End Encrypted Heirloom</span>
      </div>
    </div>
  );
};

export default PasswordGate;